export enum ProviderType {
    Internal = 'internal',
    ActiveDirectory= 'activedirectory'
}
